import cx from 'classnames';
import { useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';
import useOutsideClick from '../../../../hook/useOutsideClick';
import ScheduleDemoModal from '../ScheduleDemoModal';
import ScheduleSuccessModal from '../ScheduleSuccessModal';
import './styles.scss';
import SMSModal from '../../../../components/other/SMSModal';

const Header = ({ isOpenScheduleDemoModal, setIsOpenScheduleDemoModal }) => {
  const ourProductsRef = useRef();
  const [isOurProductsDropdownOpen, setIsOurProductsDropdownOpen] = useState(false);
  const [scheduleSuccessModalData, setScheduleSuccessModalData] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [isSMSOpen, setIsSMSOpen] = useState(false);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  };

  useOutsideClick(ourProductsRef, () => setIsOurProductsDropdownOpen(false));

  const renderHeaderLinks = () => {
    return (
      <ul className="dropdown-menu">
        <li>
          <Link to={'/education'} className="page-nav-link">
            Education
          </Link>
        </li>
        <li>
          <Link to={'/compliance'} className="page-nav-link">
            Compliance
          </Link>
        </li>
        <li>
          <Link to={'/operations'} className="page-nav-link">
            Operations
          </Link>
        </li>
        <li>
          <Link to={'/communication'} className="page-nav-link">
            Communication
          </Link>
        </li>
      </ul>
    );
  };

  return (
    <div className={cx('home-page-header', { mobile: isMobile })}>
      <div className={'home-logo'}>
        <img src="/images/logo.svg" alt="AllCareForms" />
      </div>
      {!isMobile && (
        <button className={'btn'} onClick={() => setIsSMSOpen(true)}>
          SMS opt-in consent
        </button>
      )}
      {isMobile ? (
        <>
          <div className="home-page-header-login-wrapper">
            <div className="home-page-header-schedule-demo">
              <button
                className="home-page-header-schedule-demo-btn"
                onClick={() => {
                  setMobileMenuOpen(false);
                  setIsOpenScheduleDemoModal(true);
                }}
              >
                Request a Demo{' '}
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33325 8H12.6666" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path
                    d="M8 3.33325L12.6667 7.99992L8 12.6666"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="header-menu-btn-wrapper">
              <button className="header-menu-btn" onClick={() => setMobileMenuOpen((state) => !state)}>
                {mobileMenuOpen ? (
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5 5L4.5 14" stroke="#448AFF" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.5 5L13.5 14" stroke="#448AFF" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.25 9.5H15.75" stroke="#448AFF" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2.25 5H15.75" stroke="#448AFF" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2.25 14H15.75" stroke="#448AFF" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </button>
            </div>
          </div>
          {mobileMenuOpen && (
            <div className="mobile-menu">
              <Link to="/" className="menu-item" onClick={() => setMobileMenuOpen(false)}>
                Home
              </Link>

              <div className={cx('menu-item with-submenu', { open: isProductsOpen })} onClick={() => setIsProductsOpen(!isProductsOpen)}>
                Our Solution
                <svg
                  className={cx('arrow', { open: isProductsOpen })}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.33659 12.3977C8.11692 12.178 8.11692 11.8219 8.33659 11.6022L14.0715 5.86739C14.2911 5.64772 14.6472 5.64772 14.8669 5.86739L15.1321 6.13256C15.3518 6.35222 15.3518 6.70838 15.1321 6.92805L10.0602 12L15.1321 17.0719C15.3518 17.2916 15.3518 17.6477 15.1321 17.8674L14.8669 18.1326C14.6472 18.3522 14.2911 18.3522 14.0715 18.1326L8.33659 12.3977Z"
                    fill="#A5C7FF"
                  />
                </svg>
              </div>
              {isProductsOpen && (
                <div className="submenu">
                  <Link to="/education" className="submenu-item" onClick={() => setMobileMenuOpen(false)}>
                    Education
                  </Link>
                  <Link to="/compliance" className="submenu-item" onClick={() => setMobileMenuOpen(false)}>
                    Compliance
                  </Link>
                  <Link to="/operations" className="submenu-item" onClick={() => setMobileMenuOpen(false)}>
                    Operations
                  </Link>
                  <Link to="/communication" className="submenu-item" onClick={() => setMobileMenuOpen(false)}>
                    Communication
                  </Link>
                </div>
              )}

              <Link to="/how-it-works" className="menu-item" onClick={() => setMobileMenuOpen(false)}>
                How It Works
              </Link>
              <button
                className="menu-item contact-us-btn"
                onClick={() => {
                  setMobileMenuOpen(false);
                  scrollToBottom();
                }}
              >
                Contact Us
              </button>

              <div className="menu-footer">
                <Link to="/login" className="login-btn">
                  Login
                  <svg className="ml-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H10"
                      stroke="#448AFF"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.66675 11.3334L10.0001 8.00008L6.66675 4.66675"
                      stroke="#448AFF"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path d="M10 8H2" stroke="#448AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Link>
                <button
                  className="demo-btn"
                  onClick={() => {
                    setMobileMenuOpen(false);
                    setIsOpenScheduleDemoModal(true);
                  }}
                >
                  Schedule a Demo{' '}
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.33325 8H12.6666" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                      d="M8 3.33325L12.6667 7.99992L8 12.6666"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {' '}
          <div className="home-page-header-links-wrapper">
            <div className="home-page-header-link-wrapper">
              <Link to="/">Home</Link>
            </div>
            <div className="home-page-header-link-wrapper">
              <div className="dropdown" ref={ourProductsRef}>
                <button onClick={() => setIsOurProductsDropdownOpen((state) => !state)} className="btn our-products-dropdown-button">
                  Our Solution
                  <div className="icon-wrapper">
                    <svg className="ml-2" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.8977 7.66292C6.67802 7.88259 6.32192 7.88259 6.10225 7.66292L0.367387 1.92804C0.14772 1.70837 0.14772 1.35227 0.367387 1.13259L0.632557 0.867393C0.852225 0.647718 1.20838 0.647718 1.42805 0.867393L6.49997 5.93934L11.5719 0.867393C11.7916 0.647718 12.1477 0.647718 12.3674 0.867393L12.6326 1.13259C12.8522 1.35227 12.8522 1.70837 12.6326 1.92804L6.8977 7.66292Z"
                        fill="#3571D6"
                      />
                    </svg>
                  </div>
                </button>
                {isOurProductsDropdownOpen && !isMobile && renderHeaderLinks()}
              </div>
            </div>
            <div className="home-page-header-link-wrapper">
              <Link to="/how-it-works">How It Works</Link>
            </div>
            <div className="home-page-header-link-wrapper">
              <button className="contact-us-btn" onClick={scrollToBottom}>
                Contact Us
              </button>
            </div>
          </div>
          <div className="home-page-header-login-wrapper">
            <div className="home-page-header-login">
              <Link to={'/login'} className="home-page-header-login-link">
                Login
                <svg className="ml-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H10"
                    stroke="#448AFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.66675 11.3334L10.0001 8.00008L6.66675 4.66675"
                    stroke="#448AFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path d="M10 8H2" stroke="#448AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
            </div>
            <div className="home-page-header-schedule-demo">
              <button className="home-page-header-schedule-demo-btn" onClick={() => setIsOpenScheduleDemoModal(true)}>
                Schedule a Demo{' '}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33325 8H12.6666" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path
                    d="M8 3.33325L12.6667 7.99992L8 12.6666"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}

      {isOpenScheduleDemoModal && (
        <ScheduleDemoModal
          onClose={() => {
            setIsOpenScheduleDemoModal(false);
          }}
          onSuccess={(data) => {
            setIsOpenScheduleDemoModal(false);
            setScheduleSuccessModalData(data);
          }}
        />
      )}
      <SMSModal isOpen={isSMSOpen} closeModal={() => setIsSMSOpen(false)} title={'SMS opt-in consent'}></SMSModal>

      {scheduleSuccessModalData && (
        <ScheduleSuccessModal onClose={() => setScheduleSuccessModalData(null)} data={scheduleSuccessModalData} />
      )}
    </div>
  );
};

export default Header;
